import { css } from '@emotion/react';

const center = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default center;
